// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__uYncB","title":"card_title__3dw_y","inActive":"card_inActive__1wap_"};